
// STYLES ===================================>
import '../../css/scrollbar.css';
import './notFound.css';

import notFoundImage from '../../assets/not-found-image.png';
import Logo from '../../assets/Logo.png';


function NotFound(){
    return (
        <div className='not-found-container'>
            <div className='not-found-card'>
                {/* <div className='not-found-img-wrapper'>
                    <img src={notFoundImage} className='not-found-img' alt='Página não encontrada'/>
                </div> */}

                <h1 className='not-found-404-title'>404</h1>

                <h1 className='not-found-title'>Página não encontrada</h1>
                <p className='not-found-subtitle'>Parece que esta página não existe! Considere ler novamente o QR-Code do cardápio e tente novamente.</p>

                <img src={Logo} className='not-found-logo' alt='SofChef'/>
            </div>
        </div>
    )
}

export default NotFound;
